import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  EndApiCal,
  generateTokenapi,
  getPatientchat,
  getPhysicianchat,
  patientSendmessageapi,
  physicianSendmessageapi,
  triggerApiCal,
} from "../network/Network";
import Pusher from "pusher-js";
import Header from "./Header";
import PageHeader from "./PageHeader";
import { Link } from "react-router-dom";
import {
  camera,
  cancle,
  chatcurve,
  chatcurve1,
  enterchat,
  file,
  uploadfile,
  userpatient,
} from "../Constant/Index";
import Footer from "./Footer";
import VideoCall from "./Videocall";
import VideoCallComponent from "./VideoCallComponent";
import Videohandler from "./Videohandler";
import Peer from "peerjs";
import { voice } from "../Constant/Index"; // Ensure voice is the correct path to your ringtone

function ChatComponent() {
  const dispatch = useDispatch();
  const token = useSelector((state) => state?.Auth?.token);
  const orderdetail = useSelector((state) => state?.Auth?.orderdetail);
  const allphysician = useSelector((state) => state?.Auth?.physiciandetail);
  const userDetail = useSelector((state) => state?.Auth?.users);
  const myrole = useSelector((state) => state?.Auth?.role);
  console.log(myrole, "myrole");
  const [loading, setLoading] = useState(false);
  const [notifications, setNotifications] = useState([]);
  const [patientchat, setPatientchat] = useState([]);
  const [message, setMessage] = useState("");
  const channelName = `channel_${patientchat?.chat_id}`;
  console.log(channelName, "channelName");
  const [getgeneratetoken, setGetgeneratetoken] = useState("");
  const eventName = "chatting";

  // Video Call UseStates
  const [peerId, setPeerId] = useState("");
  const [remotePeerId, setRemotePeerId] = useState("");
  const [callConnected, setCallConnected] = useState(false);
  const [isRinging, setIsRinging] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [showModals, setShowModals] = useState(false);

  const [acceptCalls, setAcceptCalls] = useState(false);
  const [endCalls, setEndCalls] = useState(false);
  const [isMuted, setIsMuted] = useState(false);

  const localVideoRef = useRef(null);
  const remoteVideoRef = useRef(null);
  const peerRef = useRef(null);
  const pusherRef = useRef(null);
  const audioRef = useRef(null);
  // ====================================

  // useEffect(() => {
  //   let data = {
  //     channelName: videoChannel,
  //   };
  //   generateTokenapi(data).then((res) => {
  //     setGetgeneratetoken(res?.data);
  //   });
  // }, []);

  // Fetch chat data initially
  // useEffect(() => {
  //   const fetchChatData = async () => {
  //     if (
  //       orderdetail?.booking_detail?.booking_id &&
  //       orderdetail?.physician_detail?.physician_id &&
  //       token
  //     ) {
  //       try {
  //         const res = await getPatientchat(
  //           orderdetail?.booking_detail?.booking_id,
  //           orderdetail?.physician_detail?.physician_id,
  //           token
  //         );
  //         setPatientchat(res?.data);
  //       } catch (error) {
  //         console.error("Error fetching patient chat:", error);
  //       }
  //     }
  //   };
  //   fetchChatData();
  // }, [orderdetail, token]);

  // Fetch chat data
  useEffect(() => {
    const fetchChatData = async () => {
      const bookingId =
        myrole == "patient"
          ? orderdetail?.booking_detail?.booking_id
          : allphysician?.booking_detail?.booking_id;

      const userId =
        myrole == "patient"
          ? orderdetail?.physician_detail?.physician_id
          : allphysician?.patient_detail?.patient_id;

      if (bookingId && userId && token) {
        try {
          const res =
            myrole == "patient"
              ? await getPatientchat(bookingId, userId, token)
              : await getPhysicianchat(bookingId, userId, token);

          setPatientchat(res?.data);
        } catch (error) {
          // console.error("Error fetching chat:", error);
        }
      }
    };
    fetchChatData();
  }, [myrole, orderdetail, allphysician, token]);
  // =================

  // Set up Pusher for real-time notifications
  useEffect(() => {
    if (!channelName || !eventName) return;

    const pusher = new Pusher("12d77ba5f11a38260c8b", {
      appId: "1885976",
      key: "12d77ba5f11a38260c8b",
      secret: "78157182ac7ca0d370e5",
      cluster: "mt1",
      forceTLS: true,
    });

    const channel = pusher.subscribe(channelName);

    // Event handler for incoming messages
    const eventHandler = (data) => {
      // console.log(data, "ajajajaja");
      // Push the new message into the chat state
      setPatientchat((prevChat) => ({
        ...prevChat,
        chats: [data.message, ...prevChat?.chats],
      }));
    };

    // Bind event handler
    channel.bind(eventName, eventHandler);

    // Cleanup on component unmount
    return () => {
      channel.unbind(eventName, eventHandler);
      pusher.unsubscribe(channelName);
      pusher.disconnect();
    };
  }, [channelName, eventName, orderdetail, allphysician, token]);
  // ===================================

  // const sendMessage = async () => {
  //   const appointmentId =
  //     myrole == "patient"
  //       ? orderdetail?.booking_detail?.booking_id
  //       : allphysician?.booking_detail?.booking_id;

  //   const userId =
  //     myrole == "patient"
  //       ? orderdetail?.physician_detail?.physician_id
  //       : allphysician?.patient_detail?.patient_id;

  //   let data;

  //   if (myrole === "patient") {
  //     data = {
  //       appointment_id: appointmentId,
  //       physician_id: userId,
  //       message,
  //     };
  //   } else {
  //     data = {
  //       appointment_id: appointmentId,
  //       patient_id: userId,
  //       message,
  //     };
  //   }

  //   try {
  //     if (myrole == "patient") {
  //       await patientSendmessageapi(data, token);
  //     } else {
  //       await physicianSendmessageapi(data, token);
  //     }

  //     // Clear message input and update local state
  //     setMessage("");
  //     setPatientchat((prevChat) => ({
  //       ...prevChat,
  //       chats: [{ message }, ...prevChat.chats],
  //     }));
  //   } catch (error) {
  //     console.error("Error sending message:", error);
  //   }
  // };
  // Send Message Api
  const sendMessage = async () => {
    setLoading(true);
    const appointmentId =
      myrole == "patient"
        ? orderdetail?.booking_detail?.booking_id
        : allphysician?.booking_detail?.booking_id;

    const userId =
      myrole == "patient"
        ? orderdetail?.physician_detail?.physician_id
        : allphysician?.patient_detail?.patient_id;

    let data;

    if (myrole === "patient") {
      data = {
        appointment_id: appointmentId,
        physician_id: userId,
        message,
      };
    } else {
      data = {
        appointment_id: appointmentId,
        patient_id: userId,
        message,
      };
    }

    try {
      if (myrole === "patient") {
        await patientSendmessageapi(data, token);
      } else {
        await physicianSendmessageapi(data, token);
      }
      // Clear the message input field only
      setMessage("");
      setLoading(false);
    } catch (error) {}
  };
  // =================

  // For Keyboard handle
  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      event.preventDefault(); // Prevents the default action, e.g., adding a new line
      sendMessage();
    }
  };
  // =================

  // Now Videocall Functionality Start
  // const MyChannelName =
  //   myrole == "patient"
  //     ? `video_patient_call_${userDetail?.id}`
  //     : `video_physician_call_${userDetail?.id}`;

  // const MyEventName =
  //   myrole == "patient"
  //     ? `video_patient_call_event_${userDetail?.id}`
  //     : `video_physician_call_event_${userDetail?.id}`;
  // const videoeventName =
  //   myrole == "patient"
  //     ? `video_physician_call_event_${userDetail?.id}`
  //     : `video_patient_call_event_${userDetail?.id}`;

  // const videochannelName =
  //   myrole == "patient"
  //     ? `video_physician_call_${userDetail?.id}`
  //     : `video_patient_call_${userDetail?.id}`;

  const MyChannelName =
    myrole == "patient"
      ? `video_patient_call_${55}`
      : `video_physician_call_${55}`;

  const MyEventName =
    myrole == "patient"
      ? `video_patient_call_event_${55}`
      : `video_physician_call_event_${55}`;
  const videoeventName =
    myrole == "patient"
      ? `video_physician_call_event_${55}`
      : `video_patient_call_event_${55}`;

  const videochannelName =
    myrole == "patient"
      ? `video_physician_call_${55}`
      : `video_patient_call_${55}`;

  const Endcallchannel = "end_call";
  const Endvideocallmyevent = "end_video_call";

  // UseEffect Ringtone
  // useEffect(() => {
  //   const peer = new Peer({ key: "peerjs", secure: true }); // Adjust with your PeerJS server key
  //   peerRef.current = peer;

  //   peer.on("open", (id) => {
  //     setPeerId(id);
  //   });

  //   peer.on("call", (call) => {
  //     setIsRinging(true);
  //     // setShowModal(true);

  //     navigator.mediaDevices
  //       .getUserMedia({ video: true, audio: true })
  //       .then((stream) => {
  //         localVideoRef.current.srcObject = stream;
  //         call.answer(stream);
  //         call.on("stream", (remoteStream) => {
  //           remoteVideoRef.current.srcObject = remoteStream;
  //           setCallConnected(true);
  //         });
  //         call.on("close", endCall);
  //       })
  //       .catch((err) => console.error("Error accessing media devices:", err));
  //   });

  //   const pusher = new Pusher("12d77ba5f11a38260c8b", { cluster: "mt1" });
  //   pusherRef.current = pusher;

  //   const channel = pusher.subscribe(MyChannelName);
  //   channel.bind(MyEventName, (data) => {
  //     console.log("Incoming Call Event:", data); // Debugging
  //     alert("datasdhcbsjv", data);
  //     if (data.pear_id) {
  //       setPeerId(data.pear_id);
  //       playRingtone();
  //       setShowModal(true);
  //     }
  //   });

  //   return () => {
  //     peer.disconnect();
  //     pusher.disconnect();
  //     stopRingtone();
  //   };
  // }, [channelName, eventName]);
  // // ===================

  // // UseEffect of End Call
  // useEffect(() => {
  //   // Initialize Pusher
  //   const pusher = new Pusher("12d77ba5f11a38260c8b", { cluster: "mt1" });
  //   pusherRef.current = pusher;

  //   // Subscribe to the channel
  //   const channel = pusher.subscribe(Endcallchannel);

  //   // Bind the event listener
  //   channel.bind(Endvideocallmyevent, (data) => {
  //     // console.log(data, "end");
  //     if (data.peer_id) {
  //       // Update state
  //       setPeerId(data.peer_id);
  //       setCallConnected(false);
  //       setEndCalls(true);
  //     }
  //   });

  //   // Cleanup on unmount
  //   return () => {
  //     if (pusherRef.current) {
  //       pusherRef.current.unsubscribe(Endcallchannel);
  //       pusherRef.current.disconnect();
  //     }
  //   };
  // }, [Endcallchannel, Endvideocallmyevent, setPeerId, setCallConnected]);
  // ===================
  useEffect(() => {
    const peer = new Peer({ key: "peerjs", secure: true });
    peerRef.current = peer;

    peer.on("open", (id) => {
      setPeerId(id);
    });

    peer.on("call", (call) => {
      setIsRinging(true);

      navigator.mediaDevices
        .getUserMedia({ video: true, audio: true })
        .then((stream) => {
          localVideoRef.current.srcObject = stream;
          call.answer(stream);
          call.on("stream", (remoteStream) => {
            remoteVideoRef.current.srcObject = remoteStream;
            setCallConnected(true);
          });
          call.on("close", endCall);
        })
        .catch((err) => console.error("Error accessing media devices:", err));
    });

    // Ensure we don't create multiple Pusher instances
    if (!pusherRef.current) {
      const pusher = new Pusher("12d77ba5f11a38260c8b", { cluster: "mt1" });
      pusherRef.current = pusher;
    }

    const channel = pusherRef.current.subscribe(MyChannelName);
    channel.bind(MyEventName, (data) => {
      console.log("Received data:", data);
      if (data.pear_id) {
        setPeerId(data.pear_id);
        playRingtone();
        setShowModal(true);
      }
    });

    return () => {
      if (peerRef.current) peerRef.current.disconnect();
      if (pusherRef.current) {
        channel.unbind(MyEventName);
        pusherRef.current.unsubscribe(MyChannelName);
      }
      stopRingtone();
    };
  }, [MyChannelName, MyEventName]);

  // ===================
  // UseEffect of End Call
  useEffect(() => {
    // Ensure we don't create multiple Pusher instances
    if (!pusherRef.current) {
      const pusher = new Pusher("12d77ba5f11a38260c8b", { cluster: "mt1" });
      pusherRef.current = pusher;
    }

    const channel = pusherRef.current.subscribe(Endcallchannel);
    channel.bind(Endvideocallmyevent, (data) => {
      if (data.peer_id) {
        setPeerId(data.peer_id);
        setCallConnected(false);
        setEndCalls(true);
      }
    });

    // Cleanup on unmount
    return () => {
      if (pusherRef.current) {
        channel.unbind(Endvideocallmyevent);
        pusherRef.current.unsubscribe(Endcallchannel);
      }
    };
  }, [Endcallchannel, Endvideocallmyevent]);

  // Play Ringtone Functionality
  const playRingtone = () => {
    if (audioRef.current) {
      audioRef.current.pause();
      audioRef.current.currentTime = 0;
    }
    const audio = new Audio(voice);
    audio.loop = true;
    audio.play().catch((err) => console.error("Failed to play ringtone:", err));
    audioRef.current = audio;
  };
  // ===========================

  // Stop ringtone
  const stopRingtone = () => {
    if (audioRef.current) {
      audioRef.current.pause();
      audioRef.current.currentTime = 0;
    }
  };
  // ==================

  // Start Call funtion
  const startCall = () => {
    navigator.mediaDevices
      .getUserMedia({ video: true, audio: true })
      .then((stream) => {
        localVideoRef.current.srcObject = stream;
        const call = peerRef.current.call(remotePeerId, stream);
        console.log("Calling Remote Peer ID:", remotePeerId);
        if (!call) {
          console.error("Call failed: No peer found");
        }

        call.on("stream", (remoteStream) => {
          remoteVideoRef.current.srcObject = remoteStream;
          setCallConnected(true);
        });
        call.on("close", endCall);

        if (!showModal) {
          triggerApiCal(
            {
              pear_id: peerId,
              channel_name: videochannelName,
              event_name: videoeventName,
            },
            token
          ).catch((err) => console.error("Failed to notify remote user:", err));
        }
      })
      .catch((err) => console.error("Failed to access media devices:", err));
  };
  // =================

  const acceptCall = () => {
    // Ensure media devices are available
    navigator.mediaDevices
      .getUserMedia({ video: true, audio: true })
      .then((stream) => {
        // Set up the local video stream
        if (localVideoRef.current) {
          localVideoRef.current.srcObject = stream;
        }

        // Initiate the call
        const call = peerRef.current.call(peerId, stream);

        // Handle incoming remote stream
        call.on("stream", (remoteStream) => {
          if (remoteVideoRef.current) {
            remoteVideoRef.current.srcObject = remoteStream;
          }
          setCallConnected(true);
        });

        // Handle call close
        call.on("close", () => {
          endCall();
        });

        // Reset modal state and stop the ringtone
        setIsRinging(false);
        setShowModal(false);
        const modalElement = document.getElementById("exampleModalToggle");
        if (modalElement) {
          const modal = new window.bootstrap.Modal(modalElement);
          modal.show();
        }
        stopRingtone();
        startCall(); // Start any post-accept call logic
      })
      .catch((error) => {
        // console.error("Error accessing media devices:", error);
        // Handle failure to access media devices
        alert(
          "Unable to access your camera or microphone. Please check permissions."
        );
      });
  };

  // End Call Function
  const endCall = async () => {
    try {
      // Stop local video and audio tracks
      if (localVideoRef.current && localVideoRef.current.srcObject) {
        const localStream = localVideoRef.current.srcObject;
        localStream.getTracks().forEach((track) => track.stop()); // Stop each track
        localVideoRef.current.srcObject = null; // Clear the video element
      }
      if (remoteVideoRef.current && remoteVideoRef.current.srcObject) {
        stopMediaStream(remoteVideoRef.current.srcObject); // Stop remote video/audio tracks
        remoteVideoRef.current.srcObject = null; // Clear the video element
      }
      setEndCalls(true);
      // Close the peer connection if it exists
      if (peerRef.current) {
        peerRef.current.close(); // Properly close the peer connection
        peerRef.current = null; // Reset the peer reference
      }

      // Notify the remote user (optional cleanup API call)
      try {
        const response = await EndApiCal(
          {
            peer_id: peerId, // Assuming 'peerId' is properly defined
            channel_name: Endcallchannel,
            event_name: Endvideocallmyevent,
          },
          token
        );
        // console.log("Remote user notified successfully:", response);
        setEndCalls(true); // Update the state to reflect the end of the call
      } catch (apiError) {
        // console.error("Failed to notify remote user via API:", apiError);
      }

      // Stop the remote video
      if (remoteVideoRef.current) {
        remoteVideoRef.current.srcObject = null; // Clear the remote video element
      }

      // Update the UI state
      setCallConnected(false);
    } catch (error) {
      // console.error("Error while ending the call:", error);
    }
  };
  // ===============

  const stopMediaStream = (stream) => {
    if (stream) {
      const tracks = stream.getTracks();
      tracks.forEach((track) => track.stop());
    }
  };
  // ==================================

  // Toggle mute/unmute
  const toggleMute = () => {
    if (audioRef.current) {
      const audioTrack = audioRef.current.getAudioTracks()[0];
      if (audioTrack) {
        audioTrack.enabled = !audioTrack.enabled;
        setIsMuted(!audioTrack.enabled);
      }
    }
  };
  // ================

  return (
    <>
      <Header />
      <PageHeader pagename="Chat" />
      <section className="chat">
        <div className="container">
          <div className="row">
            <div className="col-lg-10 mx-auto">
              <div className="main-profile-content radius-20">
                <div className="border-bottom-chat">
                  <div className="row justify-content-between align-items-center p-4">
                    <div className="col-lg-4">
                      <div className="d-flex gap-3 align-items-center">
                        {myrole == "patient" ? (
                          <img
                            src={
                              orderdetail?.physician_detail?.profile_image_url
                                ? orderdetail?.physician_detail
                                    ?.profile_image_url
                                : userpatient
                            }
                            className="img-fluid profie_img"
                            alt=""
                          />
                        ) : (
                          <img
                            src={
                              allphysician?.patient_detail?.profile_image_url
                                ? allphysician?.patient_detail
                                    ?.profile_image_url
                                : userpatient
                            }
                            className="img-fluid profie_img"
                            alt=""
                          />
                        )}

                        <div>
                          {myrole == "patient" ? (
                            <h4 className="main-heading-font mb-0 level-6">
                              {orderdetail?.physician_detail?.title}
                            </h4>
                          ) : (
                            <h4 className="main-heading-font mb-0 level-6">
                              {allphysician?.patient_detail?.title}
                            </h4>
                          )}

                          <h5 className="primary-medium-font mb-0 level-8 extra-color-15">
                            {myrole == "patient" ? "physician " : "patient"}
                            {/* 4 mins ago */}
                          </h5>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-8">
                      <div className="row mt-2">
                        <div className="col-lg-12">
                          <div className="row">
                            <div className="col-lg-4">
                              {/* {myrole == "patient" ? (
                                <Link
                                  className="btn wrapper-btn-main w-100 log-in level-7 primary-regular-font text-decoration-none"
                                  to="/user-notes"
                                >
                                  <span className="bg-wrapper w-100">
                                    <img
                                      src={file}
                                      className="img-fluid pe-3"
                                      alt=""
                                    />{" "}
                                    View Notes
                                  </span>
                                </Link>
                              ) : (
                                <Link
                                  className="btn wrapper-btn-main w-100 log-in level-7 primary-regular-font text-decoration-none"
                                  to="/physician-write-notes"
                                >
                                  <span className="bg-wrapper w-100">
                                    <img
                                      src={file}
                                      className="img-fluid pe-3"
                                      alt=""
                                    />{" "}
                                    Write Notes
                                  </span>
                                </Link>
                              )} */}
                              {myrole === "patient" ? (
                                <Link
                                  className="btn wrapper-btn-main w-100 log-in level-7 primary-regular-font text-decoration-none"
                                  to="/user-notes"
                                >
                                  <span className="bg-wrapper w-100">
                                    <img
                                      src={file}
                                      className="img-fluid pe-3"
                                      alt=""
                                    />{" "}
                                    View Notes
                                  </span>
                                </Link>
                              ) : myrole === "physician" &&
                                allphysician?.booking_detail
                                  ?.appointment_status === "Past" ? (
                                <Link
                                  className="btn wrapper-btn-main w-100 log-in level-7 primary-regular-font text-decoration-none"
                                  to="/physician-notes"
                                >
                                  <span className="bg-wrapper w-100">
                                    <img
                                      src={file}
                                      className="img-fluid pe-3"
                                      alt=""
                                    />{" "}
                                    View Notes
                                  </span>
                                </Link>
                              ) : (
                                <Link
                                  className="btn wrapper-btn-main w-100 log-in level-7 primary-regular-font text-decoration-none"
                                  to="/physician-write-notes"
                                >
                                  <span className="bg-wrapper w-100">
                                    <img
                                      src={file}
                                      className="img-fluid pe-3"
                                      alt=""
                                    />{" "}
                                    Write Notes
                                  </span>
                                </Link>
                              )}
                            </div>

                            <div className="col-lg-4">
                              {myrole == "patient" ? (
                                <Link
                                  className="btn wrapper-btn-main w-100 log-in level-7 primary-regular-font text-decoration-none"
                                  to="/user-prescription"
                                >
                                  <span className="bg-wrapper w-100">
                                    <img
                                      src={file}
                                      className="img-fluid pe-3"
                                      alt=""
                                    />{" "}
                                    View Prescription
                                  </span>
                                </Link>
                              ) : myrole === "physician" &&
                                allphysician?.booking_detail
                                  ?.appointment_status === "Past" ? (
                                <Link
                                  className="btn wrapper-btn-main w-100 log-in level-7 primary-regular-font text-decoration-none"
                                  to="/physician-prescription"
                                >
                                  <span className="bg-wrapper w-100">
                                    <img
                                      src={file}
                                      className="img-fluid pe-3"
                                      alt=""
                                    />{" "}
                                    View Prescription
                                  </span>
                                </Link>
                              ) : (
                                <Link
                                  className="btn wrapper-btn-main w-100 log-in level-7 primary-regular-font text-decoration-none"
                                  to="/write-prescription"
                                >
                                  <span className="bg-wrapper w-100">
                                    <img
                                      src={file}
                                      className="img-fluid pe-3"
                                      alt=""
                                    />{" "}
                                    Write Prescription
                                  </span>
                                </Link>
                              )}
                            </div>

                            <div className="col-lg-2">
                              {orderdetail?.booking_detail
                                ?.appointment_status == "Current" ||
                              allphysician?.booking_detail
                                ?.appointment_status == "Current" ? (
                                <div className="d-flex align-items-center justify-content-center">
                                  <div className="edit-btn chat-user">
                                    {/* <Link 
                                          class="btn btn-primary"
                                          data-bs-toggle="modal"
                                          href="#exampleModalToggle"
                                          role="button"
                                    >
                                      <img
                                        src={camera}
                                        className="img-fluid"
                                        alt=""
                                      />
                                    </Link> */}
                                    {/* <a
                                      className="btn btn-primary"
                                      data-bs-toggle="modal"
                                      href="#exampleModalToggle"
                                      role="button"
                                      onClick={(e) => startCall(e, peerId)}
                                    >
                                      <img
                                        src={camera}
                                        className="img-fluid"
                                        alt=""
                                      />
                                    </a> */}
                                    <button
                                      className="btn btn-primary"
                                      data-bs-toggle="modal"
                                      data-bs-target="#exampleModalToggle"
                                      onClick={(e) => startCall(e, peerId)}
                                    >
                                      <img
                                        src={camera}
                                        className="img-fluid"
                                        alt="Camera Icon"
                                      />
                                    </button>
                                  </div>
                                </div>
                              ) : null}
                            </div>

                            <div className="col-lg-2">
                              <div className="d-flex align-items-center justify-content-center">
                                <div className="edit-btn chat-user">
                                  {myrole == "patient" ? (
                                    <Link
                                      to={`/consultation-detail/${orderdetail?.booking_detail?.booking_id}`}
                                    >
                                      <img
                                        src={cancle}
                                        className="img-fluid"
                                        alt=""
                                      />
                                    </Link>
                                  ) : (
                                    <Link
                                      to={`/physician-consultation-detail/${allphysician?.booking_detail?.booking_id}`}
                                    >
                                      <img
                                        src={cancle}
                                        className="img-fluid"
                                        alt=""
                                      />
                                    </Link>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="chat-main p-4">
                  {myrole == "patient" ? (
                    <>
                      {patientchat?.chats?.map((item, cindex) => {
                        return (
                          <div
                            key={cindex}
                            className={
                              item?.send_by === "physician"
                                ? "main-physician-massage"
                                : "main-user-massage"
                            }
                          >
                            <div
                              className={
                                item?.send_by === "physician"
                                  ? "physician-massage"
                                  : "user-massage"
                              }
                            >
                              <p>{item?.message}</p>
                              <h4>{item?.time}</h4>{" "}
                              {/* Correctly format the timestamp */}
                              <div
                                className={
                                  item?.send_by === "physician"
                                    ? "chat-curve-img-left"
                                    : "chat-curve-img-right"
                                }
                              >
                                <img
                                  src={
                                    item?.send_by === "physician"
                                      ? chatcurve
                                      : chatcurve1
                                  }
                                  className="img-fluid"
                                  alt=""
                                />
                              </div>
                            </div>
                          </div>
                        );
                      })}
                    </>
                  ) : (
                    <>
                      {patientchat?.chats?.map((item, cindex) => {
                        return (
                          <div
                            key={cindex}
                            className={
                              item?.send_by === "patient"
                                ? "main-physician-massage"
                                : "main-user-massage"
                            }
                          >
                            <div
                              className={
                                item?.send_by === "patient"
                                  ? "physician-massage"
                                  : "user-massage"
                              }
                            >
                              <p>{item?.message}</p>
                              <h4>{item?.time}</h4>{" "}
                              {/* Correctly format the timestamp */}
                              <div
                                className={
                                  item?.send_by === "patient"
                                    ? "chat-curve-img-left"
                                    : "chat-curve-img-right"
                                }
                              >
                                <img
                                  src={
                                    item?.send_by === "patient"
                                      ? chatcurve
                                      : chatcurve1
                                  }
                                  className="img-fluid"
                                  alt=""
                                />
                              </div>
                            </div>
                          </div>
                        );
                      })}
                    </>
                  )}
                </div>
                {orderdetail?.booking_detail?.appointment_status == "Current" ||
                allphysician?.booking_detail?.appointment_status ==
                  "Current" ? (
                  <div className="chat-input">
                    <div className="row align-items-center">
                      <div className="col-lg-10">
                        <div className="form-group">
                          <textarea
                            placeholder="Write Your Message"
                            value={message}
                            onChange={(e) => setMessage(e.target.value)}
                            onKeyDown={handleKeyDown} // Add this to listen for Enter key
                          ></textarea>
                        </div>
                      </div>
                      <div className="col-lg-1">
                        {/* <div className="file-upload text-end">
                        <img src={uploadfile} alt="" className="img-fluid" />
                      </div> */}
                      </div>
                      <div className="col-lg-1">
                        <div className=" file-upload">
                          <span className="loading-btn-chat loading">
                            {loading ? (
                              <i className="fa fa-spinner"></i>
                            ) : (
                              <img
                                onClick={sendMessage}
                                src={enterchat}
                                alt=""
                                className="img-fluid"
                              />
                            )}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                ) : null}
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* <VideoCall  app={appId} tok={getgeneratetoken?.token} channelName={videoChannel} eventName={"video-call"}/> */}
      {/* <VideoCall tok={getgeneratetoken?.token} userId={orderdetail?.booking_detail?.booking_id} channelName={videoChannel} /> */}

      {/* <VideoCallComponent /> */}
      {/* <Videohandler /> */}

      <div>
        {!endCalls == true ? (
          <div className="video_modal">
            <div
              className="modal fade video_modal"
              id="exampleModalToggle"
              aria-hidden="true"
              aria-labelledby="exampleModalToggleLabel"
              tabIndex="-1"
            >
              <div className="modal-dialog modal-dialog-centered modal-fullscreen">
                <div className="modal-content">
                  <div className="modal-header"></div>
                  <div
                    className="modal-body"
                    style={{
                      overflow: "hidden",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "10px",
                        width: "100%",
                        height: "100%",
                      }}
                    >
                      {!callConnected ? (
                        <video
                          style={{
                            width: "100%",
                            maxHeight: "100%",
                            objectFit: "cover",
                            borderRadius: "8px",
                          }}
                          className="own_video"
                          ref={localVideoRef}
                          autoPlay
                          muted
                        />
                      ) : (
                        <video
                          style={{
                            width: "20%",
                            maxHeight: "100%",
                            objectFit: "cover",
                            borderRadius: "8px",
                          }}
                          className="own_video"
                          ref={localVideoRef}
                          autoPlay
                          muted
                        />
                      )}

                      <video
                        style={{
                          width: "100%",
                          maxHeight: "100%",
                          objectFit: "cover",
                          borderRadius: "8px",
                        }}
                        className="front_video"
                        ref={remoteVideoRef}
                        autoPlay
                      />
                    </div>
                  </div>
                  <div className="modal-footer ">
                    <div className="button_voice">
                      <button>
                        <i
                          onClick={toggleMute}
                          className="fa fa-microphone"
                          aria-hidden="true"
                        ></i>
                      </button>
                      <button className="mike_mute">
                        <i
                          className="fa fa-microphone-slash"
                          aria-hidden="true"
                        ></i>
                      </button>
                      <button onClick={endCall} className="concel_color">
                        <i className="fa fa-phone" aria-hidden="true"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : null}

        {showModal && (
          <div
            className="modal show receive_modal"
            tabIndex="-1"
            style={{ display: "block" }}
          >
            <div className="modal-dialog">
              <div className="modal-content">
                <div className="modal-header justify-content-center">
                  {myrole == "patient" ? (
                    <img
                      src={
                        orderdetail?.physician_detail?.profile_image_url
                          ? orderdetail?.physician_detail?.profile_image_url
                          : userpatient
                      }
                      className="img-fluid profie1_img"
                      alt=""
                    />
                  ) : (
                    <img
                      src={
                        allphysician?.patient_detail?.profile_image_url
                          ? allphysician?.patient_detail?.profile_image_url
                          : userpatient
                      }
                      className="img-fluid profie1_img"
                      alt=""
                    />
                  )}
                </div>
                <div className="modal-body text-center">
                  {myrole == "patient" ? (
                    <h4 className="main-heading-font mb-0 level-6">
                      {orderdetail?.physician_detail?.title}
                    </h4>
                  ) : (
                    <h4 className="main-heading-font mb-0 level-6">
                      {allphysician?.patient_detail?.title}
                    </h4>
                  )}{" "}
                </div>
                <div className="modal-footer justify-content-center">
                  {/* <button
                    type="button"
                    className="btn btn-success"
                    onClick={acceptCall}
                  >
                    Accept
                  </button> */}
                  <button onClick={acceptCall} className="accept_color">
                    <i className="fa fa-phone" aria-hidden="true"></i>
                  </button>
                  <button className="concel_color">
                    <i className="fa fa-phone" aria-hidden="true"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>

      {/* <div
        class="modal fade"
        id="exampleModalToggle2"
        aria-hidden="true"
        aria-labelledby="exampleModalToggleLabel2"
        tabindex="-1"
      >
        <div class="modal-dialog modal-dialog-centered modal-fullscreen">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="exampleModalToggleLabel2">
                Modal 2
              </h5>
              <button
                type="button"
                class="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div class="modal-body">
              Hide this modal and show the first with the button below.
            </div>
            <div class="modal-footer">
              <button
                class="btn btn-primary"
                data-bs-target="#exampleModalToggle"
                data-bs-toggle="modal"
                data-bs-dismiss="modal"
              >
                Back to first
              </button>
            </div>
          </div>
        </div>
      </div> */}
      {/* <a
        class="btn btn-primary"
        data-bs-toggle="modal"
        href="#exampleModalToggle"
        role="button"
      >
        Open first modal
      </a> */}
      {/* <VideoCallComponent /> */}

      <Footer />
    </>
  );
}

export default ChatComponent;
